import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./reducers/UserReducer";
import profileReducer from "./reducers/profileReducer";
import dropdownReducer from "./reducers/dropdownReducer";
import KddReducer from "./reducers/KddReducer";
import DataIngestionReducer from "./reducers/DataIngestionReducer";
import ASAPReducer from "./reducers/ASAPReducer";
import DateReducer from "./reducers/DateReducer";
import TitleReducer from "./reducers/TitleReducer";
import FilenameReducer from "./reducers/FileNameReducer";
import ExistingPreviewReducer from "./reducers/ExistingPreviewReducer";
import UserManagementReducer from './reducers/UserManagementReducer'
import MarketingActivityReducer from './reducers/MarketingActivity'
import ASAPFileReducer from './reducers/ASAPFileReducer';
import AsapTitleOptionReducer from './reducers/AsapTitleOptionReducer'
import BookBubReducer from './reducers/BookBubReducer'
import ISBNBookBubReducer from './reducers/ISBNBookBubReducer'
import TitleBookBobReducer from './reducers/TitleBookBubReducer'
import DealBookBubReducer from './reducers/DealBookBubReducer'
export const store = configureStore({
  reducer: {
    UserReducer,
    profileReducer,
    dropdownReducer,
    KddReducer,
    DataIngestionReducer,
    ASAPReducer,
    DateReducer,
    TitleReducer,
    FilenameReducer,
    ExistingPreviewReducer,UserManagementReducer,
    MarketingActivityReducer,AsapTitleOptionReducer,ASAPFileReducer,BookBubReducer,ISBNBookBubReducer,TitleBookBobReducer,DealBookBubReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppStore = typeof store; // type of our store variable

// Infer the RootState and App type from the store itself
export type RootState = ReturnType<AppStore["getState"]>;

export type AppDispatch = AppStore["dispatch"];
